import React from 'react'
import { Row, Col, FormGroup, FormControl, ControlLabel } from 'react-bootstrap'
import { Link } from 'react-router'
import i18next from 'i18next'
import validator from 'validator'
import Notificator from './Notificator'
import GridContainer from './GridContainer'
import WopiInvitationError from './smart/WopiInvitationErrorContainer'
import OrderCreditsModal from './OrderCreditsModal'
import NoMoreCredits from './NoMoreCredits'
import Credits from './Credits'
import Button from './Button'

import adminStyles from './styles/admin.scss'
import invitationStyles from './styles/invitation.scss'

import { availableLanguages } from './../assets/translations/availableLanguages'

export default class WopiInvitation extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      language: props.currentLanguage,
      organisation: '',
      role: '',

      recipients: '',
      emailDisclaimer: false,
      title: '',
      message: '',
      signature: props.currentAccount.signature,

      invitationMethod: 'email',
      recipientCount: 1,

      form: {
        isValid: false,
        invalidEmails: [],
        isRecipientCountValid: true
      },

      orderModalActive: false
    }
  }

  componentWillMount() {
    this.setDefaultsForLanguageDeterminedFields(this.state.language)
  }

  handleDismissNoMoreWopiCredits = e => {
    e.preventDefault()

    this.props.onDismissNoMoreWopiCredits()
  }

  handleOrderWopiCreditsOpen = e => {
    e.preventDefault()

    this.setState({
      orderModalActive: true
    })
  }

  handleOrderWopiCreditsClose = e => {
    e.preventDefault()

    this.setState({
      orderModalActive: false
    })
  }

  render() {
    const { currentOrganisation, noMoreWopiCredits } = this.props
    const { invitationMethod } = this.state
    const creditsWopi = currentOrganisation.organisation.creditsWopi

    return (
      <GridContainer>
        <OrderCreditsModal
          isModalVisible={this.state.orderModalActive}
          handleClose={this.handleOrderWopiCreditsClose}
        />

        <div className={adminStyles.app}>
          <Row>
            <Col md={10} mdOffset={1}>
              <header>
                <h1>{i18next.t('new_questionnaire')}</h1>

                <Credits credits={creditsWopi} handleOrder={this.handleOrderWopiCreditsOpen} />
              </header>

              <WopiInvitationError />

              {noMoreWopiCredits && (
                <NoMoreCredits handleDismiss={this.handleDismissNoMoreWopiCredits} />
              )}

              <Row className={invitationStyles.formContainer}>
                <Col md={3} className={invitationStyles.products}>
                  <ul>
                    <li className={invitationStyles.activeProduct}>
                      <h3>WOPI</h3>

                      <p>{i18next.t('product_selection_wopi_description')}</p>
                    </li>
                  </ul>
                </Col>

                <Col md={9} className={invitationStyles.form}>
                  <Row>
                    <Col md={12}>
                      <h2>{i18next.t('questionnaire_extra_information')}</h2>

                      <p>{i18next.t('questionnaire_extra_information_description')}</p>

                      <FormGroup controlId="organisation">
                        <ControlLabel>{i18next.t('organisation')}</ControlLabel>
                        <FormControl
                          name="organisation"
                          type="text"
                          placeholder={i18next.t('invitation_organisation_description')}
                          onChange={this.onChange.bind(this)}
                          value={this.state.organisation}
                        />
                      </FormGroup>

                      <FormGroup controlId="role">
                        <ControlLabel>{i18next.t('role')}</ControlLabel>
                        <FormControl
                          name="role"
                          type="text"
                          placeholder={i18next.t('invitation_role_description')}
                          onChange={this.onChange.bind(this)}
                          value={this.state.role}
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={12}>
                      <h2>{i18next.t('questionnaire_invitations')}</h2>

                      <FormGroup controlId="language">
                        <ControlLabel>{i18next.t('invitation_language')}</ControlLabel>
                        <FormControl
                          componentClass="select"
                          onChange={this.onChangeLanguage.bind(this)}
                          defaultValue={this.state.language}
                        >
                          {availableLanguages.map((l, key) => (
                            <option value={l.key} key={key}>
                              {i18next.t(l.translationKey)}
                            </option>
                          ))}
                        </FormControl>
                      </FormGroup>

                      <FormGroup controlId="invitationMethod">
                        <ControlLabel>{i18next.t('invitationMethod')}</ControlLabel>
                        <FormControl
                          name="invitationMethod"
                          componentClass="select"
                          onChange={this.onChange.bind(this)}
                          defaultValue={invitationMethod}
                        >
                          <option value="email">{i18next.t('email')}</option>
                          <option value="linkOnly">{i18next.t('linkOnly')}</option>
                        </FormControl>
                      </FormGroup>

                      {invitationMethod === 'linkOnly' && (
                        <FormGroup
                          controlId="recipientCount"
                          validationState={this.state.form.isRecipientCountValid ? null : 'error'}
                        >
                          <ControlLabel>
                            {i18next.t('recipients_count')}

                            {!this.state.form.isRecipientCountValid && (
                              <div className={invitationStyles.invalidRecipientsCount}>
                                <p>{i18next.t('check_recipients_count')}</p>
                              </div>
                            )}
                          </ControlLabel>
                          <FormControl
                            name="recipientCount"
                            type="number"
                            min={1}
                            max={9}
                            placeholder=""
                            onChange={this.onChange.bind(this)}
                            value={this.state.recipientCount}
                          />
                        </FormGroup>
                      )}

                      {invitationMethod === 'email' && (
                        <div>
                          <FormGroup controlId="title">
                            <ControlLabel>{i18next.t('invitation_subject')}</ControlLabel>
                            <FormControl
                              name="title"
                              type="text"
                              placeholder=""
                              onChange={this.onChange.bind(this)}
                              value={this.state.title}
                            />
                          </FormGroup>

                          <FormGroup
                            controlId="recipients"
                            validationState={
                              this.state.form.invalidEmails.length > 0 ? 'error' : null
                            }
                          >
                            <ControlLabel>
                              {i18next.t('recipients')}

                              {this.state.form.invalidEmails.length > 0 && (
                                <div className={invitationStyles.invalidEmails}>
                                  <p>{i18next.t('check_invalid_emails')}</p>

                                  {this.state.form.invalidEmails.map((e, key) => (
                                    <span key={key}>{e}</span>
                                  ))}
                                </div>
                              )}
                            </ControlLabel>
                            <FormControl
                              name="recipients"
                              componentClass="textarea"
                              placeholder={i18next.t('recipients_description')}
                              onChange={this.onChange.bind(this)}
                              value={this.state.recipients}
                              rows="4"
                              style={{ maxWidth: '100%' }}
                            />
                          </FormGroup>

                          <FormGroup controlId="message">
                            <ControlLabel>{i18next.t('invitation_message')}</ControlLabel>
                            <FormControl
                              name="message"
                              componentClass="textarea"
                              rows="5"
                              placeholder=""
                              onChange={this.onChange.bind(this)}
                              value={this.state.message.replace(/\\n/g, '\n')}
                            />
                          </FormGroup>

                          <p style={{ margin: '10px 0 15px' }}>
                            {i18next.t('generated_invitation_link_here_description')}
                          </p>

                          <FormGroup controlId="signature">
                            <ControlLabel>{i18next.t('signature')}</ControlLabel>
                            <FormControl
                              name="signature"
                              componentClass="textarea"
                              rows="4"
                              placeholder={i18next.t('edit_your_signature_description')}
                              onChange={this.onChange.bind(this)}
                              value={this.state.signature}
                            />
                          </FormGroup>
                        </div>
                      )}
                    </Col>
                  </Row>

                  <Notificator type="info">
                    <p>{i18next.t('notification_profile_deletion_description')}</p>
                    <br />

                    <p>{i18next.t('notification_profile_as_administrator_description')}</p>
                  </Notificator>
                  {invitationMethod === 'email' && (
                    <FormGroup controlId="emailDisclaimer" style={{ paddingTop: '20px' }}>
                      <input
                        id="email-disclaimer"
                        type="checkbox"
                        name="emailDisclaimer"
                        onChange={this.onChangeToggleChecked.bind(this)}
                        defaultChecked={this.state.emailDisclaimer}
                      />
                      <span style={{ paddingLeft: '10px' }}>
                        {i18next.t('email_disclaimer_checkbox_label')}
                      </span>
                    </FormGroup>
                  )}
                </Col>
              </Row>
            </Col>
          </Row>

          <div id="submit-button-container" style={{ textAlign: 'center', marginBottom: 20 }}>
            {invitationMethod === 'email' && (
              <Button
                text={i18next.t('send_invitations')}
                onClick={this.onSendInvitations.bind(this)}
                disabled={!this.state.form.isValid || this.props.isSendingInvitations}
              />
            )}

            {invitationMethod === 'linkOnly' && (
              <Button
                text={i18next.t('generate_links')}
                onClick={this.onGenerateLinksOnly.bind(this)}
                disabled={
                  (!this.state.form.isRecipientCountValid ||
                    this.props.isGeneratingInvitationLinks) &&
                  this.state.emailDisclaimer
                }
              />
            )}

            <span style={{ marginLeft: 5 }}>
              {i18next.t('or')}&nbsp;<Link to="/">{i18next.t('cancel')}</Link>
            </span>
          </div>
        </div>
      </GridContainer>
    )
  }

  onChange(e) {
    this.setState({ [e.target.name]: e.target.value }, this.validateState)
  }

  onChangeToggleChecked(e) {
    this.setState({ [e.target.name]: e.target.checked }, this.validateState)
  }

  validateState() {
    const validate = () => {
      const recipients = this.transformRecipientStringToArray(this.state.recipients)
      const invalidEmails = recipients.filter(email => !validator.isEmail(email))

      return {
        isValid:
          this.state.title.trim() != '' &&
          this.state.message.trim() != '' &&
          recipients.length > 0 &&
          invalidEmails.length == 0 &&
          this.state.emailDisclaimer,
        invalidEmails: invalidEmails,
        isRecipientCountValid: this.state.recipientCount > 0 && this.state.recipientCount < 10
      }
    }

    this.setState({ form: validate() })
  }

  onChangeLanguage(e) {
    this.setState({ language: e.target.value })

    this.setDefaultsForLanguageDeterminedFields(e.target.value)
  }

  setDefaultsForLanguageDeterminedFields(language) {
    i18next.loadLanguages(language, (err, t) => {
      const lang = i18next.getFixedT(language)

      this.setState({
        title: lang('invitation_to_wopi'),
        message: lang('invitation_message_wopi'),
        linkDescription: lang('invitation_start_link')
      })
    })
  }

  onSendInvitations() {
    const recipients = this.transformRecipientStringToArray(this.state.recipients)

    this.props.onSendInvitations(
      this.props.currentOrganisationId,
      recipients,
      this.state.title,
      this.state.message,
      this.state.signature,
      this.state.organisation,
      this.state.role,
      this.state.language
    )
  }

  onGenerateLinksOnly() {
    this.props.onGenerateNoEmailInvitations(
      this.props.currentOrganisationId,
      this.state.recipientCount,
      this.state.organisation,
      this.state.role,
      this.state.language
    )
  }

  transformRecipientStringToArray(recipients) {
    return recipients
      .split(/\,|\n|\s/g)
      .map(email => email.toLowerCase().trim())
      .filter(email => email != '')
  }
}



// WEBPACK FOOTER //
// ./src/components/WopiInvitation.js